(function () {
  'use strict';

  var root = document.getElementById('kaashi-cart-root');
  if (!root) return;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('kaashi-cart-config').textContent); } catch (e) { CFG = {}; }
  var M = CFG.milestones || {};

  var inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  function fmt(rupees) { return inr.format(Math.round(rupees || 0)); }
  function money(cents) { return fmt((cents || 0) / 100); }

  var milestones = [
    { value: M.freeShipping || 799, label: 'Free shipping', reward: 'free shipping', pinLabel: 'Unlock free shipping!' },
    { value: M.discountThreshold || 1290, label: 'Unlock flat ' + fmt(M.discountAmount || 291) + ' off!', reward: fmt(M.discountAmount || 291) + ' off', pinLabel: 'Unlock flat ' + fmt(M.discountAmount || 291) + ' off!' },
    { value: M.giftThreshold || 1500, label: 'Free gift', reward: 'a free gift', pinLabel: 'Unlock free gift!' }
  ].sort(function (a, b) { return a.value - b.value; });
  var barMax = milestones[milestones.length - 1].value;
  var barMin = (CFG.barStart != null ? CFG.barStart : 300);
  var barSpan = (barMax - barMin) || 1;
  function posPct(v) { return Math.max(0, Math.min((v - barMin) / barSpan, 1)) * 100; }

  var el = {
    bar: root.querySelector('[data-kaashi-bar]'),
    smart: root.querySelector('[data-kaashi-smart]'),
    reward: root.querySelector('[data-kaashi-reward]'),
    items: root.querySelector('[data-kaashi-items]'),
    empty: root.querySelector('[data-kaashi-empty]'),
    upsell: root.querySelector('[data-kaashi-upsell]'),
    upsellList: root.querySelector('[data-kaashi-upsell-list]'),
    title: root.querySelector('[data-kaashi-title]'),
    timer: root.querySelector('[data-kaashi-timer]'),
    urgency: root.querySelector('[data-kaashi-urgency]'),
    totals: root.querySelector('[data-kaashi-totals]')
  };

  var processingGift = false;
  var lastSub = null;
  var pool = [];

  function loadPool() {
    var h = CFG.upsellCollection || 'all';
    return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        pool = (d.products || []).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          if (!v) return null;
          return {
            title: p.title,
            price: Math.round(parseFloat(v.price) * 100),
            image: (p.images && p.images[0]) ? p.images[0].src : '',
            variantId: v.id,
            available: !!v.available
          };
        }).filter(Boolean);
      })
      .catch(function () { pool = []; });
  }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function addItem(id, qty, props) {
    var item = { id: id, quantity: qty || 1 };
    if (props) item.properties = props;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) }).then(function (r) { return r.json(); });
  }

  function nonGiftSubtotal(cart) {
    var sub = cart.items_subtotal_price || 0;
    (cart.items || []).forEach(function (it) {
      if (it.properties && it.properties._kaashi_gift) sub -= it.final_line_price;
    });
    return Math.round(sub / 100);
  }

  function manageGift(cart) {
    if (processingGift || !CFG.giftVariantId) return Promise.resolve(cart);
    var threshold = M.giftThreshold || 1500;
    var sub = nonGiftSubtotal(cart);
    var giftLine = (cart.items || []).filter(function (it) { return it.properties && it.properties._kaashi_gift; })[0];
    if (sub >= threshold && !giftLine) {
      processingGift = true;
      return addItem(CFG.giftVariantId, 1, { _kaashi_gift: 'true' }).then(getCart)
        .then(function (c) { processingGift = false; return c; })
        .catch(function () { processingGift = false; return cart; });
    }
    if (sub < threshold && giftLine) {
      processingGift = true;
      return changeLine(giftLine.key, 0).then(getCart)
        .then(function (c) { processingGift = false; return c; })
        .catch(function () { processingGift = false; return cart; });
    }
    return Promise.resolve(cart);
  }

  function buildBar(sub, crossed) {
    crossed = crossed || [];
    var pct = posPct(sub);
    var dots = milestones.map(function (m, i) {
      var pos = ((i + 1) / milestones.length) * 100;
      var done = sub >= m.value;
      var pulse = crossed.indexOf(m.value) !== -1 ? ' kaashi-pulse' : '';
      return '<span class="kaashi-dot' + (done ? ' done' : '') + pulse + '" style="left:' + pos + '%">' + (done ? '\u2713' : '') + '</span>';
    }).join('');
    var labels = milestones.map(function (m, i) {
      var pos = ((i + 1) / milestones.length) * 100;
      var tx = pos >= 99 ? 'translateX(-88%)' : 'translateX(-50%)';
      return '<span class="kaashi-mlabel" style="left:' + pos + '%;transform:' + tx + '">' + m.label + '<br><b>' + fmt(m.value) + '</b></span>';
    }).join('');
    var next = milestones.filter(function (m) { return m.value > sub; })[0];
    var nudge = next ? ('Add ' + fmt(next.value - sub) + ' more to unlock ' + next.reward) : 'You have unlocked every reward';
    var pinTx = pct >= 90 ? 'translateX(-85%)' : (pct <= 10 ? 'translateX(-15%)' : 'translateX(-50%)');
    var pop = crossed.length ? ' kaashi-pin-pop' : '';
    var pinLabel = next ? next.pinLabel : 'All rewards unlocked!';
    var pin = '<span class="kaashi-pin" style="left:' + pct + '%;transform:' + pinTx + '"><span class="kaashi-pin-pill' + pop + '">' + pinLabel + '</span><span class="kaashi-pin-tip"></span></span>';
    return '<div class="kaashi-nudge">' + nudge + '</div><div class="kaashi-bar-sub">' + nudge + '</div><div class="kaashi-track"><span class="kaashi-fill" style="width:' + pct + '%"></span>' + dots + pin + '</div><div class="kaashi-mlabels">' + labels + '</div>';
  }

  function buildReward(sub) {
    var dT = M.discountThreshold || 1290, dA = M.discountAmount || 291, gT = M.giftThreshold || 1500;
    if (CFG.giftVariantId && sub >= gT) return 'Your free gift is in the cart.';
    if (sub >= dT) return 'You unlocked ' + fmt(dA) + ' off. This box is now ' + fmt(sub - dA) + '.';
    return null;
  }

  function buildItems(cart) {
    return (cart.items || []).map(function (it) {
      var isGift = it.properties && it.properties._kaashi_gift;
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="kaashi-item-variant">' + it.variant_title + '</div>' : '';
      var price = isGift ? '<span class="kaashi-free">FREE</span>' : money(it.final_line_price);
      var ctrl = isGift
        ? '<span class="kaashi-giftbadge">Free gift</span>'
        : '<span class="kaashi-qty"><button data-key="' + it.key + '" data-act="dec" aria-label="Decrease">\u2212</button><span>' + it.quantity + '</span><button data-key="' + it.key + '" data-act="inc" aria-label="Increase">+</button></span>';
      var img = it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '';
      return '<div class="kaashi-item"><div class="kaashi-thumb">' + img + '</div><div class="kaashi-item-mid"><div class="kaashi-item-title">' + it.product_title + '</div>' + variant + ctrl + '</div><div class="kaashi-item-price">' + price + '</div></div>';
    }).join('');
  }

  function buildTotals(cart, sub) {
    var dT = M.discountThreshold || 1290, dA = M.discountAmount || 291;
    var eligible = sub >= dT;
    var html = '<div class="kaashi-row"><span>Subtotal</span><span>' + fmt(sub) + '</span></div>';
    if (eligible) html += '<div class="kaashi-row kaashi-save"><span>Reward saving</span><span>\u2212 ' + fmt(dA) + '</span></div>';
    html += '<div class="kaashi-row kaashi-pay"><span>To pay</span><span>' + fmt(eligible ? sub - dA : sub) + '</span></div><div class="kaashi-shiphint">before shipping</div>';
    return html;
  }

  function urgencyVisible() {
    var now = new Date();
    var ist = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + 5.5 * 3600000);
    return ist.getHours() < 17;
  }

  function pickSmartUpsell(cart, sub) {
    if (CFG.showUpsell === false || !pool.length) return null;
    var next = milestones.filter(function (m) { return m.value > sub; })[0];
    if (!next) return null;
    var gap = next.value - sub;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; });
    var cands = pool.filter(function (u) {
      return u.available !== false && !inCart[u.variantId] && u.variantId !== CFG.giftVariantId;
    });
    if (!cands.length) return null;
    var rupees = function (u) { return Math.round(u.price / 100); };
    var crossing = cands.filter(function (u) { return rupees(u) >= gap; }).sort(function (a, b) { return a.price - b.price; });
    var pick = crossing.length ? crossing[0] : cands.slice().sort(function (a, b) { return b.price - a.price; })[0];
    return { product: pick, reward: next.reward, crosses: rupees(pick) >= gap };
  }

  function renderSmart(cart, sub) {
    if (!el.smart) return;
    var s = pickSmartUpsell(cart, sub);
    if (!s) { el.smart.hidden = true; return; }
    var p = s.product;
    var rupees = Math.round(p.price / 100);
    var gap = s.crosses ? (rupees - (milestones.filter(function (m) { return m.value > sub; })[0].value - sub)) : null;
    var gapLine = s.crosses
      ? ('Add for ' + money(p.price) + ' · unlocks ' + s.reward)
      : ('Add ' + money(p.price) + ' to get closer to ' + s.reward);
    var badgeLabel = s.crosses ? ('UNLOCKS ' + s.reward.toUpperCase()) : 'ADD TO UNLOCK ' + s.reward.toUpperCase();
    var img = p.image ? '<img src="' + p.image + '" alt="">' : '';
    var pct = s.crosses ? Math.round((1 - rupees / (rupees + (milestones.filter(function (m) { return m.value > sub; })[0].value - sub))) * 100) : 0;
    var pctTag = pct > 0 ? '<span class="kaashi-smart-pct">' + pct + '% OFF</span>' : '';
    el.smart.hidden = false;
    el.smart.innerHTML =
      '<div class="kaashi-smart-badge">' + badgeLabel + '</div>' +
      '<div class="kaashi-smart-body">' +
        '<div class="kaashi-smart-img">' + img + '</div>' +
        '<div class="kaashi-smart-mid">' +
          '<div class="kaashi-smart-title">' + p.title + '</div>' +
          '<div class="kaashi-smart-gap">' + gapLine + '</div>' +
          '<div class="kaashi-smart-pricing">' +
            '<span class="kaashi-smart-now">' + money(p.price) + '</span>' +
            pctTag +
          '</div>' +
        '</div>' +
        '<button class="kaashi-smart-add" data-variant="' + p.variantId + '">Add</button>' +
      '</div>';
    var add = el.smart.querySelector('.kaashi-smart-add');
    add.addEventListener('click', function () {
      add.disabled = true; add.textContent = '...';
      addItem(p.variantId, 1).then(getCart).then(update);
    });
  }

  function renderUpsell(cart) {
    if (!el.upsell) return;
    if (CFG.showUpsell === false || !pool.length) { el.upsell.hidden = true; return; }
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; });
    var list = pool.filter(function (u) {
      return u.available !== false && !inCart[u.variantId] && u.variantId !== CFG.giftVariantId;
    }).slice(0, 6);
    if (!list.length) { el.upsell.hidden = false; el.upsellList.innerHTML = ''; return; }
    el.upsell.hidden = false;
    var labelEl = el.upsell.querySelector('[data-kaashi-upsell-label]');
    if (labelEl) labelEl.textContent = Math.floor(60 + Math.random() * 12) + '% of shoppers added these too';
    el.upsellList.innerHTML = list.map(function (u) {
      var rupees = Math.round(u.price / 100);
      var mrp = Math.round(rupees * 1.12);
      var off = Math.round((1 - rupees / mrp) * 100);
      var img = u.image ? '<img src="' + u.image + '" alt="">' : '';
      return '<div class="kaashi-up">' +
        '<div class="kaashi-up-img">' + img + '<span class="kaashi-up-off">' + off + '% OFF</span></div>' +
        '<div class="kaashi-up-body">' +
          '<div class="kaashi-up-title">' + u.title + '</div>' +
          '<div class="kaashi-up-prices"><span class="kaashi-up-was">' + fmt(mrp) + '</span><span class="kaashi-up-now">' + money(u.price) + '</span></div>' +
          '<button class="kaashi-up-add" data-variant="' + u.variantId + '">ADD</button>' +
        '</div>' +
      '</div>';
    }).join('');
    el.upsellList.querySelectorAll('.kaashi-up-add').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = '...';
        addItem(parseInt(b.getAttribute('data-variant'), 10), 1).then(getCart).then(update);
      });
    });
  }
  function bindItems() {
    el.items.querySelectorAll('.kaashi-qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var span = btn.parentNode.querySelector('span');
        var q = parseInt(span.textContent, 10);
        var nq = btn.getAttribute('data-act') === 'inc' ? q + 1 : q - 1;
        if (nq < 0) nq = 0;
        changeLine(key, nq).then(update);
      });
    });
  }

  function update(cart) {
    return manageGift(cart).then(function (c) {
      var sub = nonGiftSubtotal(c);
      var crossed = [];
      if (lastSub !== null) {
        milestones.forEach(function (m) {
          if (lastSub < m.value && sub >= m.value) { crossed.push(m.value); ph('kaashi_milestone_unlocked', { value: m.value }); }
        });
      }
      lastSub = sub;
      el.bar.innerHTML = buildBar(sub, crossed);
      renderSmart(c, sub);
      el.items.innerHTML = buildItems(c);
      el.title.textContent = ((CFG.copy && CFG.copy.heading) || 'Your cart') + ' \u00b7 ' + c.item_count;
      el.empty.hidden = c.item_count > 0;
      el.items.hidden = c.item_count === 0;
      var rw = buildReward(sub);
      el.reward.hidden = !rw;
      if (rw) el.reward.textContent = rw;
      el.totals.innerHTML = buildTotals(c, sub);
      renderUpsell(c);
      if (el.urgency) { el.urgency.textContent = (CFG.copy && CFG.copy.urgency) || ''; el.urgency.style.display = urgencyVisible() ? '' : 'none'; }
      bindItems();
      return c;
    });
  }

  function ph(ev, props) { if (window.posthog && window.posthog.capture) { try { window.posthog.capture(ev, props || {}); } catch (e) {} } }

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  var timerInt = null;
  var TIMER_SECS = (CFG.timerMinutes ? CFG.timerMinutes : 5) * 60;
  function timerStart() {
    if (!el.timer || CFG.showTimer === false) return;
    var key = 'kaashi_timer_start';
    var start;
    try { start = sessionStorage.getItem(key); } catch (e) { start = null; }
    if (!start) { start = String(Date.now()); try { sessionStorage.setItem(key, start); } catch (e) {} }
    start = parseInt(start, 10);
    function tick() {
      var rem = Math.max(0, TIMER_SECS - Math.floor((Date.now() - start) / 1000));
      var mm = Math.floor(rem / 60), ss = rem % 60;
      var t = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
      el.timer.hidden = false;
      el.timer.innerHTML = rem > 0
        ? '&#9201; Hurry! Only <strong style="font-size:14px;margin:0 2px">' + t + '</strong> mins left to checkout'
        : '&#9201; Checkout now before your cart expires';
      if (rem <= 0 && timerInt) { clearInterval(timerInt); timerInt = null; }
    }
    tick();
    if (timerInt) clearInterval(timerInt);
    timerInt = setInterval(tick, 1000);
  }
  function timerStop() { if (timerInt) { clearInterval(timerInt); timerInt = null; } }

  function openDrawer() { root.classList.add('is-open'); lock(true); timerStart(); ph('kaashi_cart_opened'); }
  function closeDrawer() { root.classList.remove('is-open'); lock(false); timerStop(); }
  function refresh() { return getCart().then(update); }

  root.querySelectorAll('[data-kaashi-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  var coBtn = root.querySelector('[data-kaashi-checkout]');
  if (coBtn) coBtn.addEventListener('click', function (e) {
    ph('kaashi_checkout_click');
    if ((CFG.checkoutMode || 'trigger') === 'url') {
      e.preventDefault();
      window.location.href = CFG.checkoutUrl || '/cart';
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-kaashi-cart-open], a[href="/cart"], a[href$="/cart"]');
    if (opener && !opener.closest('#kaashi-cart-root')) {
      e.preventDefault();
      refresh().then(openDrawer);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    var submitter = e.submitter;
    if (submitter && submitter.getAttribute('data-flexy-type') === 'buynow') return;
    if (root.getAttribute('data-enabled') === 'false') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function () { ph('kaashi_add_to_cart'); return refresh(); })
      .then(openDrawer)
      .catch(function () { form.submit(); });
  }, true);

  window.KaashiCart = { open: function () { refresh().then(openDrawer); }, close: closeDrawer, refresh: refresh };

  refresh();
  loadPool().then(refresh);
})();